export const RegionLookupService = {
    BY_CONTENT: "contents",
    BY_EVENT: "contents"
};


// WEBPACK FOOTER //
// ./src/helpers/enums/RegionLookupServiceEnum.js